import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditGruppoTipiDannoComponent } from './dialogs/edit/edit.component';
import { GruppiTipiDannoComponent } from './gruppi-tipi-danno.component';



@NgModule({
  declarations: [GruppiTipiDannoComponent,
    EditGruppoTipiDannoComponent,],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
  ],
  exports: [GruppiTipiDannoComponent,
    EditGruppoTipiDannoComponent,]
})
export class GruppiTipiDannoModule { }
